import CourseView from "./components/CourseView"
import UpcomingCourses from "./components/UpcomingCourses"

let module = "frontend"

export default [
  {
    path: "view/:id/uuid/:uuid",
    component: CourseView,
    props: true,
    meta: { module: module, permissions: ["all"] }
  },
  {
    path: "upcoming",
    component: UpcomingCourses,
    props: true,
    meta: { module: module, permissions: ["all"] }
  }
]
